import { useEffect, useState } from "react";
import "./App.css";
import Routers from "./routes";
import "react-toastify/dist/ReactToastify.css";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import AdminLogin from "./pages/admin/adminLogin";
import AdminRegister from "./pages/admin/Register";
import { useAppContext } from "./context/appContext";
import Loading from "./components/loading";
import { logo, miniLogo } from "./assets";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { auth } from "./config/config";
import { TOKEN_KEY } from "./config/variable";

function App() {
  const { UserType, showSignUp, setShowSignUp } = useAppContext();
  const [isVerified, setIsVerified] = useState(false);
  const [loading, setLoading] = useState(true); // Tracks if the verification check is still loading

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const storageType = urlParams.get("storageType");
    const data = urlParams.get("data");

    // If we have fresh login data in the URL, always prefer it and override
    if (data && storageType) {
      try {
        const parsedData = JSON.parse(decodeURIComponent(data));

        // Clear any existing auth data so the new login (and storageType)
        // always take effect, even if a previous login was stored.
        localStorage.removeItem(TOKEN_KEY);
        sessionStorage.removeItem(TOKEN_KEY);

        if (storageType === "localStorage") {
          localStorage.setItem(TOKEN_KEY, JSON.stringify(parsedData));
        } else {
          sessionStorage.setItem(TOKEN_KEY, JSON.stringify(parsedData));
        }

        window.history.replaceState({}, document.title, "/createReport");
        window.location.href = "/createReport";
        return;
      } catch (error) {
        console.error("Error parsing login data:", error);
        // Clean up URL and redirect to login on error
        window.history.replaceState({}, document.title, "/login");
        window.location.href = "/login";
        return;
      }
    }

    const isSavedInStorage =
      localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);

    if (isSavedInStorage) {
      // If already logged in and on root with params, clean up URL
      if (urlParams.get("storageType") || urlParams.get("data")) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    }
  }, []);

  const AuthWrapper = ({ children }) => {
    const navigate = useNavigate();

    if (!isVerified) {
      return showSignUp ? (
        <AdminRegister setShowSignUp={setShowSignUp} />
      ) : (
        <AdminLogin setShowSignUp={setShowSignUp} />
      );
    }

    // Render children if the user is verified
    return children;
  };

  return (
    <Routers />

    // {/* <AuthWrapper>
    // </AuthWrapper> */}
  );
}

export default App;
